import type { ISubscriptionDetails } from '@shared/types';

export enum PaylinkState {
	CREATED = 'CREATED',
	ACTIVE = 'ACTIVE',
	EXPIRED = 'EXPIRED',
	COMPLETED = 'COMPLETED',
	CANCELLED = 'CANCELLED',
	FAILED = 'FAILED',
	ERRORED = 'ERRORED',
}

export interface IPaylinkDetail {
	amount: number;
	currency: string;
	description: string;
	merchantId: string;
	merchantName: string;
	merchantReferenceId: string;
	orderId: string;
	state: PaylinkState;
	updatedAt: number;
	expireAt?: number;
	phoneNumberRequired?: boolean;
	subscriptionDetails?: ISubscriptionDetails;
}
